import SpriteSymbol from "../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 42 34",
  "content": "<symbol viewBox=\"0 0 42 34\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"check\">\n  <g stroke=\"none\" stroke-width=\"1\">\n    <g transform=\"translate(-662.000000, -238.000000)\">\n      <polygon id=\"check_Path\" points=\"704 243.666667 681.6 266.333333 681.6 266.333333 676 272 670.4 266.333333 670.4 266.333333 662 257.833333 667.6 252.166667 676 260.666667 698.4 238\" />\n    </g>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol